import {createUserManager} from 'redux-oidc';
import {IDENTITY_CONFIG} from './authConst';

const userManager = createUserManager(IDENTITY_CONFIG);

export default userManager;